import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.css']
})
export class ColumnComponent implements OnInit {
  @Input() column: FormGroup;
  @Input() index: number;
  @Input() fieldlist: string[];
 
  constructor() { }

  ngOnInit(): void {
    if (this.Field == 'select') {
      this.column.disable();
    }
  }

  get Field() {
    return this.column.get('Field').value;
  }
}
